module.exports = __webpack_public_path__ + "static/media/25.50b0edc2.jpg";